import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './browser-support.module.scss';
import Chrome from '../../assets/icons/chrome.svg';
import Safari from '../../assets/icons/safari.svg';
import { ReactComponent as ZipVector } from '../../assets/icons/zip-vector.svg';
import { HIDE_SNACKBAR, SHOW_SNACKBAR } from '../../store/action-types';
import Snackbar from '../snackbar/snackbar.component';
import { RootState } from '../../store/reducers';

type ISafariSupportComponent = {
  continueClick: () => void;
};

const SafariSupportComponent: React.FC<ISafariSupportComponent> = ({
  continueClick,
}) => {
  const { snackbar } = useSelector((state: RootState) => state.common);
  const dispatch = useDispatch();
  return (
    <>
      {snackbar?.visible && (
        <Snackbar
          {...snackbar}
          handleClose={() => dispatch({ type: HIDE_SNACKBAR, payload: snackbar })}
        />
      )}
      <div className={styles['safari-support-container']}>
        <div className={styles['inner-container']}>
          <div className={styles['header']}>
            <div className={styles['logo']}>
              <ZipVector className="w-4 h-6 lg:w-5 lg:h-7 text-white fill-current" />
            </div>
            <div className={styles['text']}>ZIPTEAMS</div>
          </div>
          <div className={styles['content']}>
            <div className={styles['content-header']}>
              It’s not you, its us!
            </div>
            <div className={styles['content-text']}>
              All meetings features are not supported on Safari. You may not be
              able to change your audio device and minimize the meeting screen.
              Please use Chrome browser for best experience.
            </div>
          </div>
          <div className={styles['actions']}>
            <button
              type="button"
              className="cursor-pointer px-5 py-3 lg:py-2.5 flex items-center justify-center bg-secondary rounded gap-2 text-white font-bold text-xs lg:text-base"
              onClick={() => {
                window.navigator.clipboard.writeText(window.location.href);
                dispatch({
                  type: SHOW_SNACKBAR,
                  payload: {
                    type: 'success',
                    message: 'Meeting Link copied',
                  },
                });
              }}
            >
              <img
                src={Chrome}
                alt="chrome"
                className="w-6 h-6 lg:w-8 lg:h-8"
              />
              Copy link and open in Chrome
            </button>
            <button
              type="button"
              className="cursor-pointer px-5 py-3 lg:py-2.5 flex items-center justify-center bg-transparent rounded gap-2 text-secondary font-bold text-xs lg:text-base"
              onClick={() => {
                continueClick();
              }}
            >
              <img
                src={Safari}
                alt="chrome"
                className="w-6 h-6 lg:w-8 lg:h-8"
              />
              Continue on Safari
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default SafariSupportComponent;
